import styled, { css } from 'styled-components';
import { AiOutlineCheck } from 'react-icons/ai';
import { transparentize } from 'polished';

interface DivProps {
  error?: boolean;
  height?: string;
  newData?: boolean;
  isChildren?: boolean;
  haveChildren?: boolean;
}

export const Input = styled.input<DivProps>`
  width: ${({ isChildren }) => (isChildren ? '155%' : '100%')};
  height: 100%;
  color: ${(props) => props.theme.colors.black};
  background: ${(props) =>
    props.readOnly
      ? transparentize(0.3, props.theme.colors.white)
      : props.theme.colors.white};
  border: none;
  font-weight: 400;
  padding-left: ${({ isChildren }) => (isChildren ? '0px' : '20px')};
  padding-right: 20px;
  font-size: 16px;

  ${(props) =>
    props.newData &&
    !props.isChildren &&
    css`
      font-family: ${(props) => props.theme.primaryFont};
      font-style: normal;
      line-height: 14px;
      color: #222222;
      font-weight: bold;
      text-align: center;
      border-radius: ${(props) =>
        Number(props.theme.radiusCards)
          ? `${props.theme.radiusCards}px`
          : '60px'}; ;
    `};

  ${(props) =>
    props.newData &&
    props.isChildren &&
    css`
      font-family: ${(props) => props.theme.primaryFont};
      font-style: normal;
      line-height: 14px;
      color: #222222;
      font-weight: bold;
      border-radius: none;
    `};

  ::-webkit-input-placeholder {
    color: ${(props) => props.theme.colors.gray};
    padding-top: 5px;
    text-overflow: ellipsis;
    overflow: visible;

    ${(props) =>
      props.newData &&
      props.isChildren &&
      css`
        font-family: ${(props) => props.theme.primaryFont};
        font-style: normal;
        line-height: 14px;
        font-weight: normal;
        text-align: left;
      `};

    ${(props) =>
      props.newData &&
      !props.isChildren &&
      css`
        font-family: ${(props) => props.theme.primaryFont};
        font-style: normal;
        line-height: 14px;
        font-weight: normal;
        text-align: center;
      `};
  }

  @media screen and (max-width: 960px) {
    width: 100%;
    height: 100%;

    ${(props) =>
      props.newData &&
      css`
        border-radius: ${(props) =>
          Number(props.theme.radiusCards)
            ? `${props.theme.radiusCards}px`
            : '10px'}; ;
      `};
  }
`;

export const TagError = styled.div<DivProps>`
  position: ${({ haveChildren }) => (haveChildren ? 'absolute' : 'relative')};
  padding: 3px 8px 2px 8px;
  background: ${(props) => props.theme.colors.danger};
  font-weight: 700;
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.theme.colors.white};
  width: max-content;
  border-radius: 16px;
  top: ${({ haveChildren }) => (haveChildren ? '25px' : '-9px')};
  right: ${({ haveChildren }) => (haveChildren ? '34%' : 'initial')};
  margin: 0 auto;

  @media (max-width: 960px) {
    right: ${({ haveChildren }) => (haveChildren ? '32%' : 'initial')};
  }
`;

export const Column = styled.div<DivProps>`
  width: 100%;
  height: ${(props) => props.height};
  border-radius: ${({ newData }) => (newData ? '60px' : '4px')};
  border: ${(props) =>
    props.error
      ? `2px solid ${props.theme.colors.danger}`
      : `1.5px solid ${props.theme.colors.lightGray}`};

  ${(props) =>
    props.newData &&
    !props.isChildren &&
    css`
      border: ${props.error
        ? `2px solid ${props.theme.colors.danger}`
        : 'none'};
      box-shadow: -4px -4px 8px rgba(36, 36, 36, 0.1),
        4px 4px 6px rgba(36, 36, 36, 0.1);
    `};

  ${(props) =>
    props.newData &&
    props.isChildren &&
    css`
      border: none;
      box-shadow: none;
      flex: 2;
    `};

  @media screen and (max-width: 960px) {
    width: 100%;
    height: ${(props) => props.height};

    ${(props) =>
      props.newData &&
      css`
        border-radius: ${(props) =>
          Number(props.theme.radiusCards)
            ? `${props.theme.radiusCards}px`
            : '10px'}; ;
      `};
  }
`;

export const IconCheck = styled(AiOutlineCheck)`
  width: 30px;
  height: 20px;
  color: ${(props) => props.theme.colors.success};
  position: relative;
  top: -32px;
  float: right;
  margin-right: 10px;
`;
